/**
 * Non-breaking space character
 * Used to prevent line breaks between elements
 */
export const NBSP = '\xa0';
